import type { Id } from "@teachloop/backend/_generated/dataModel";
import React, { type ComponentType, useCallback } from "react";
import { FlatList, View } from "react-native";
import useResponsiveWidth from "@/elements/hooks/use-responsive-width";
import LessonHistoryEmptyState from "./lesson-history-empty-state";
import TutorLessonHistoryItem, {
  type TutorLessonHistoryItemData,
} from "./tutor-lesson-history-item";

type TutorLessonHistoryListProps = {
  ListHeaderComponent: ComponentType<any>;
  lessonReports: TutorLessonHistoryItemData[];
  onProcessLessonReport: (args: {
    lessonReportId: Id<"lessonReports">;
    skipRecordings?: boolean;
  }) => Promise<unknown>;
};

function TutorLessonHistoryList({
  ListHeaderComponent,
  lessonReports,
  onProcessLessonReport,
}: TutorLessonHistoryListProps) {
  const responsiveWidth = useResponsiveWidth();

  const renderItem = useCallback(
    ({ item }: { item: (typeof lessonReports)[number] }) => (
      <View className="mx-5">
        <TutorLessonHistoryItem
          item={item}
          onProcessLessonReport={onProcessLessonReport}
        />
      </View>
    ),
    [onProcessLessonReport],
  );

  const ListEmptyComponent = useCallback(() => {
    return <LessonHistoryEmptyState />;
  }, []);

  return (
    <FlatList
      data={lessonReports}
      renderItem={renderItem}
      contentContainerStyle={{ width: responsiveWidth, alignSelf: "center" }}
      ListHeaderComponent={ListHeaderComponent}
      ListEmptyComponent={ListEmptyComponent}
      ItemSeparatorComponent={() => (
        <View className="h-[1px] bg-gray-200 mx-5" />
      )}
      ListFooterComponent={() => <View className="h-[1px] bg-gray-200 mx-5" />}
    />
  );
}

export default TutorLessonHistoryList;
